import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import LinearProgress from '@material-ui/core/LinearProgress';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { Button, Box, Modal } from '@solvhealth/jigsaw-v1';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { colors } from '../../../../../constants/colors';
import { biggerThanOrEqualTo } from '../../../../../core/util/styledComponents';
import { safeGet } from '../../../../../core/util/object';
import {
  getHealthInsuranceProfileByProfileId,
  getProfileFromAccountSummary,
} from '../../../../../core/util/account';
import { Actions, Events } from './analytics';
import ContentCards from './ContentCards';
import { shouldShowSwimlanes } from '../util/insuranceDetails';
import { INSURANCE_TUTORIAL_MODAL } from '../../../../../constants/modalIds';

const ProgressBar = styled(LinearProgress).withConfig({ componentId: 'sc-1rru7nz-0' })`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  ${biggerThanOrEqualTo.sm`
    left: 20px;
    width: calc(100% - 40px);
  `}

  height: 5px;
  background-color: ${colors.theWhiteAlbum};
  > div {
    background-color: ${colors.crunchBerry};
  }
`;

const ButtonContainer = styled.div.withConfig({ componentId: 'sc-1rru7nz-1' })`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  padding-top: 8px;
`;

type InsuranceTutorialModalProps = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  closeModal?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  fullScreen?: bool;
  insuranceDetails?: object;
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  insuranceDetailsSubmitting?: bool;
  insuranceProfile?: object;
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  open?: bool;
  userProfile?: object;
  userProfileId: string;
  npi?: object;
};

export class InsuranceTutorialModal extends PureComponent<InsuranceTutorialModalProps, any> {
  contentCards: any;

  hasRegistered: any;

  constructor(props: InsuranceTutorialModalProps) {
    super(props);
    const cardProps = ContentCards.getCardProps(props);
    const cards = this.getCards();
    // @ts-expect-error ts-migrate(2349) FIXME: Each member of the union type '{ <S extends typeof... Remove this comment to see the full error message
    this.contentCards = cards.filter((card: any) => card.isVisible({ ...cardProps }));
    this.state = { cardIndex: 0 };
  }

  componentDidUpdate(prevProps: InsuranceTutorialModalProps) {
    const cardProps = ContentCards.getCardProps(prevProps);
    const cards = this.getCards();
    // @ts-expect-error ts-migrate(2349) FIXME: Each member of the union type '{ <S extends typeof... Remove this comment to see the full error message
    this.contentCards = cards.filter((card: any) => card.isVisible({ ...cardProps }));
  }

  componentWillUnmount() {
    this.deregisterNavListener();
  }

  getCards = () => {
    const { insuranceDetails, insuranceDetailsSubmitting, insuranceProfile, npi } = this.props;
    return shouldShowSwimlanes({
      detailsResult: insuranceDetails,
      insuranceDetailsSubmitting,
      insuranceProfile,
      npi,
    })
      ? ContentCards.Personalized
      : ContentCards.Generic;
  };

  getProgressPercentage = () => ((this.state.cardIndex + 1) / this.contentCards.length) * 100;

  getTrackingProps = () => {
    const { insuranceDetails, insuranceDetailsSubmitting, insuranceProfile, npi } = this.props;
    const variant = shouldShowSwimlanes({
      detailsResult: insuranceDetails,
      insuranceDetailsSubmitting,
      insuranceProfile,
      npi,
    })
      ? 'Personalized'
      : 'Generic';
    return {
      cardCount: this.contentCards.length,
      cardIndex: this.state.cardIndex,
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      insuranceProfileId: this.props.userProfile.insurance_profile_id,
      userProfileId: this.props.userProfileId,
      variant,
    };
  };

  handleClickBack = (card: any) => () => {
    const trackingProps = this.getTrackingProps();
    analyticsTrackEvent(Events.INSURANCE_TUTORIAL, {
      action: Actions.CLICK_BACK,
      ...trackingProps,
      cardName: card.name,
    });
    const { cardIndex } = this.state;
    if (cardIndex > 0) {
      this.setState({ cardIndex: cardIndex - 1 });
    }
  };

  handleClickNext = (card: any) => () => {
    const trackingProps = this.getTrackingProps();
    analyticsTrackEvent(Events.INSURANCE_TUTORIAL, {
      action: Actions.CLICK_NEXT,
      ...trackingProps,
      cardName: card.name,
    });
    const { cardIndex } = this.state;
    if (cardIndex < this.contentCards.length - 1) {
      this.setState({ cardIndex: cardIndex + 1 });
    }
  };

  handleClickClose = (card: any) => () => {
    const trackingProps = this.getTrackingProps();
    analyticsTrackEvent(Events.INSURANCE_TUTORIAL, {
      action: Actions.CLICK_CLOSE,
      ...trackingProps,
      cardName: card.name,
    });
    this.deregisterNavListener();
    this.setState({ cardIndex: 0 });
    this.props.closeModal(INSURANCE_TUTORIAL_MODAL);
  };

  registerNavListener = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'pushState' does not exist on type 'Histo... Remove this comment to see the full error message
    window.history.pushState(null, null, '#insurance101');
    this.hasRegistered = true;
    window.addEventListener('hashchange', this.captureBack);
  };

  deregisterNavListener = () => {
    window.removeEventListener('hashchange', this.captureBack);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'pushState' does not exist on type 'Histo... Remove this comment to see the full error message
    this.hasRegistered && window.history.pushState(null, null, window.location.pathname);
  };

  captureBack = (e: any) => {
    e && e.preventDefault();

    const { cardIndex } = this.state;
    const ContentCard = this.contentCards[cardIndex];
    this.handleClickClose(ContentCard)();
  };

  shouldShowBack = () => this.state.cardIndex !== 0;

  shouldShowNext = () => this.state.cardIndex !== this.contentCards.length - 1;

  render() {
    const { open } = this.props;
    const { cardIndex } = this.state;
    const cardProps = {
      ...ContentCards.getCardProps(this.props),
      cardCount: this.contentCards.length,
    };
    const ContentCard = this.contentCards[cardIndex];

    return (
      <Modal
        footer={
          <ButtonContainer>
            {this.shouldShowBack() && (
              <Button onClick={this.handleClickBack(ContentCard)} variant="text">
                BACK
              </Button>
            )}
            <Button
              ml="auto"
              onClick={
                this.shouldShowNext()
                  ? this.handleClickNext(ContentCard)
                  : this.handleClickClose(ContentCard)
              }
              variant="contained"
            >
              {this.shouldShowNext() ? 'NEXT' : 'Check it out'}
            </Button>
          </ButtonContainer>
        }
        header={
          <ProgressBar
            color="secondary"
            value={this.getProgressPercentage()}
            variant="determinate"
          />
        }
        onClose={this.handleClickClose(ContentCard)}
        open={open}
        variant="long"
      >
        <Box height={{ _: '100%', md: '480px' }}>
          <ContentCard {...cardProps} cardIndex={cardIndex} cardName={ContentCard.name} />
        </Box>
      </Modal>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  insuranceDetails: safeGet(state.insuranceDetails.result, {})(`${ownProps.userProfileId}`),
  userProfile: getProfileFromAccountSummary(state.account.summary, ownProps.userProfileId),
  insuranceDetailsSubmitting: state.insuranceDetails.submitting,
  insuranceProfile: getHealthInsuranceProfileByProfileId(
    state.account.summary,
    ownProps.userProfileId
  ),
  npi: state.npi,
});

const ConnectedModal = connect(mapStateToProps, null)(InsuranceTutorialModal);

export default withMobileDialog<InsuranceTutorialModalProps>({ breakpoint: 'xs' })(ConnectedModal);
